import { setPageToVisitJobMatchScore } from "../constants/matchPreviewHandoff";

const STORAGE_KEY = "wb_acquisition";

export const JNN_PARTNER_SOURCE = "jnn";

export const isJnnPartnerLink = (search) => {
  const params = new URLSearchParams(search);
  return params.get("utm_source") === JNN_PARTNER_SOURCE;
};

const isUserLoggedIn = () =>
  !!localStorage.getItem("token") && !!localStorage.getItem("userData");

const redirectLoggedInUserToJobMatchScore = () => {
  if (
    isUserLoggedIn() &&
    !window.location.pathname.startsWith("/job-match-score")
  ) {
    window.location.replace("/job-match-score");
    return true;
  }
  return false;
};

const parseUtmParams = (search) => {
  const params = new URLSearchParams(search);
  const source = params.get("utm_source");
  const medium = params.get("utm_medium");
  const campaign = params.get("utm_campaign");
  const ref = params.get("ref");
  const inviteToken = params.get("token");

  // Contact invite links: /signup/{username}?ref=contact_invite&token=...
  if (ref === "contact_invite" || inviteToken) {
    return {
      acquisition_source: "contact_invite",
      acquisition_medium: medium || "email",
      acquisition_campaign: campaign || "grow_your_network",
      invite_token: inviteToken || null,
      ref: "contact_invite",
    };
  }

  if (!source && !medium && !campaign) {
    return null;
  }

  return {
    acquisition_source: source || null,
    acquisition_medium: medium || null,
    acquisition_campaign: campaign || null,
  };
};

export const captureAcquisitionFromUrl = () => {
  if (typeof window === "undefined") {
    return;
  }

  const search = window.location.search;

  if (isJnnPartnerLink(search)) {
    setPageToVisitJobMatchScore();
    if (redirectLoggedInUserToJobMatchScore()) {
      return;
    }
  }

  const acquisition = parseUtmParams(search);
  if (!acquisition) {
    return;
  }

  // Contact invite attribution should win over a stale prior UTM capture
  if (acquisition.acquisition_source === "contact_invite") {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(acquisition));
    return;
  }

  if (localStorage.getItem(STORAGE_KEY)) {
    return;
  }

  localStorage.setItem(STORAGE_KEY, JSON.stringify(acquisition));
};

export const getStoredAcquisition = () => {
  if (typeof window === "undefined") {
    return {};
  }

  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) {
      return {};
    }

    const parsed = JSON.parse(stored);
    if (!parsed || typeof parsed !== "object") {
      return {};
    }

    return {
      ...(parsed.acquisition_source ? { acquisition_source: parsed.acquisition_source } : {}),
      ...(parsed.acquisition_medium ? { acquisition_medium: parsed.acquisition_medium } : {}),
      ...(parsed.acquisition_campaign ? { acquisition_campaign: parsed.acquisition_campaign } : {}),
      ...(parsed.invite_token ? { invite_token: parsed.invite_token } : {}),
      ...(parsed.ref ? { ref: parsed.ref } : {}),
    };
  } catch (error) {
    return {};
  }
};

export const clearStoredAcquisition = () => {
  if (typeof window !== "undefined") {
    localStorage.removeItem(STORAGE_KEY);
  }
};
